import { camelCase, isObject, mapKeys } from "lodash";

export const isURL = (url: string) => {
  try {
    new URL(url);
    return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: any) {
    return false;
  }
};

export const camelizeObjectKeys = (obj: any): any => {
  if (!isObject(obj)) return obj;
  if (Array.isArray(obj)) return obj.map(camelizeObjectKeys);

  return mapKeys(
    Object.keys(obj).reduce((result: any, key) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      result[key] = camelizeObjectKeys(obj[key]);
      return result;
    }, {}),
    (_, key) => camelCase(key),
  );
};

export const callOrDefault = <T>(
  fn: (() => T) | undefined,
  defaultValue: T,
): T => {
  if (typeof fn === "function") {
    try {
      return fn();
    } catch {
      return defaultValue;
    }
  }
  return defaultValue;
};
